import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class downloadableFiles {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      direction: 'horizontal',
      centeredSlides: false,
      breakpoints: {
        320: {
          slidesPerView: 1.25,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 2.25,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
      pagination: {
        el: this.strip.find('.swiper-pagination')[0],
        type: 'bullets',
        clickable: true,
      },
    })
  }
}

export default downloadableFiles
